import Vue from 'vue'
import Vuex from 'vuex'
import api from './api.js'
import { router } from '../main'

Vue.use(Vuex)

var apiRoot = '/api'
if(process.env.NODE_ENV == 'development') {apiRoot = 'http://localhost:8000/api' }

function isEmptyObject(o) {
    return Object.keys(o).some(function(x) {
        return o[x]===''||o[x]===null;  // or just "return o[x];" for falsy values
    });
}

const store = new Vuex.Store({
	state: {
		token: null,
		user: JSON.parse(localStorage.getItem('user')),
		isLoggedIn: !!localStorage.getItem('token'),
		experiment: {},
		experiments_list : [],
		molecules: [],
		profile: {},
		profile_updated: false,
		is_profile_filled: true,
		errors: {}
	},
	getters: {
		
		isLoggedIn: state => state.isLoggedIn,
		getUser: state => state.user,
		getErrors: state => () => state.errors,
		getProfileUpdated: state => () => state.profile_updated,
		getProfileFilled: state => state.is_profile_filled
		
		
	},
	mutations: {
		'LOGIN_SUCCESS': function(state, params) {
			let response = params[0]
			let is_registred = params[1]
			state.isLoggedIn = true
			state.token = response.body.token
		    state.user = response.body.user
		    
		    localStorage.setItem('token', response.body.token)
		    localStorage.setItem('user', JSON.stringify(response.body.user))
		    
		    Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
			
			if(is_registred) router.push('/profile') //redirect new user to profile page 
		    else state.is_profile_filled = true
		},
		
		'LOGOUT_SUCCESS': function(state, response){
			localStorage.removeItem('token')
		    localStorage.removeItem('user')
		    
			state.token = null
		    state.user = {}
		    state.isLoggedIn = false
		    
		    
		},
		'GET_PROFILE': function(state, response){
			let obj_profile = response.body[0]
			state.profile = obj_profile
			
			//check if all fields in profile are filled
			if(!isEmptyObject(obj_profile)) state.is_profile_filled = true
			else state.is_profile_filled = false
			
		},
		'UPDATE_PROFILE': function(state, response){
			state.profile_updated = !state.profile_updated
			state.is_profile_filled = true
		},
		'ADD_EXPERIMENT': function(state, response){
			
			state.experiment = response.body
		},
		'GET_EXPERIMENT': function(state, response){
			let experiment = response.body
			
			let mols=[]
			experiment.reactions.forEach( function( obj) {
			     let molecule = obj.molecule
				 molecule.guess = obj.reaction
				 molecule.data = obj.data
			     mols.push(molecule);
			   })
			state.molecules = mols
			state.experiment = experiment
		},
		'DELETE_EXPERIMENT': function(state, experiment_id){
			
			let i = state.experiments_list.map(item => item.id).indexOf(experiment_id) // find index of your object
			state.experiments_list.splice(i, 1) // remove it from array

		},
		'GET_EXPERIMENT_LIST': function(state, response){
			
			state.experiments_list = response.body
			
		},
		'GET_MOLECULES': function(state, response){
			state.molecules = response.body
		},
		'RATE_MOLECULE': function(state, response){
			
		},
		'API_FAIL': function (state, error) {
		    console.error(error)
		    state.errors = error
		    
		}
	},
	actions:{
		login(store, payload){
			return api.post(apiRoot + '/rest-auth/login/', {'username':payload.login, 'password':payload.password })
	          .then((response) => store.commit('LOGIN_SUCCESS', [response, 0]))
	          .catch((error) => store.commit('API_FAIL', error))
			
		},
		logout(store){
			return api.post(apiRoot + '/rest-auth/logout/')
	          .then((response) => store.commit('LOGOUT_SUCCESS', response))
	          .catch((error) => store.commit('API_FAIL', error))
		},
		register(store, payload){
			return api.post(apiRoot + '/rest-auth/registration/', {'username': payload.username, 
                                                                   'email': payload.email,
                                                                   'password1': payload.password1,
                                                                   'password2': payload.password2})
	          .then((response) => store.commit('LOGIN_SUCCESS', [response, 1]))
	          .catch((error) => store.commit('API_FAIL', error))
		},
		getProfile(store){
			let user = JSON.parse(localStorage.getItem('user'))
			return api.get(apiRoot + '/profile/', {'user': user.id})
	          .then((response) => store.commit('GET_PROFILE', response))
	          .catch((error) => store.commit('API_FAIL', error))
		},
		updateProfile(store, payload){
			return api.patch(apiRoot + '/profile/'+payload.profile.id+'/', payload.profile)
	          .then((response) => store.commit('UPDATE_PROFILE', response))
	          .catch((error) => store.commit('API_FAIL', error))
		},
		addExperiment(store, payload){
			
			console.log('Adding an Experiment: ' + JSON.stringify(payload))

			return api.post(apiRoot + '/experiments/', {'user': payload.user, 'exp_type': payload.exp_type})
	          .then((response) => store.commit('ADD_EXPERIMENT', response))
	          .catch((error) => store.commit('API_FAIL', error))
		},
		rateMolecule(context, payload){
			let store = context;
			let state = context.state;
			console.log(state.experiment.id)
			return api.post(apiRoot + '/molecule-reactions/', {'experiment': state.experiment.id, 
                                                               'molecule': payload.molecule, 
															   'reaction': payload.reaction,
															   'data': payload.data,
															   'rawdata': payload.rawdata})
	          .then((response) => store.commit('RATE_MOLECULE', response))
	          .catch((error) => store.commit('API_FAIL', error))
		},
		getExperiment(store, experiment_id){
			return api.get(apiRoot + '/experiments/'+experiment_id+'/')
             .then((response) => store.commit('GET_EXPERIMENT', response))
             .catch((error) => store.commit('API_FAIL', error))
		},
		deleteExperiment(store, experiment_id){
			return api.delete(apiRoot + '/experiments/'+experiment_id+'/')
             .then((response) => store.commit('DELETE_EXPERIMENT', experiment_id))
             .catch((error) => store.commit('API_FAIL', error))
		},
		getExperimentList(store){
			return api.get(apiRoot + '/experiments/')
            .then((response) => store.commit('GET_EXPERIMENT_LIST', response))
            .catch((error) => store.commit('API_FAIL', error))
		},
		getMolecules(store){
			return api.get(apiRoot + '/molecules/')
	          .then((response) => store.commit('GET_MOLECULES', response))
	          .catch((error) => store.commit('API_FAIL', error))
		}
	}
})	

export default store


// WEBPACK FOOTER //
// ./src/store/store.js